import React from 'react';

const addonsImage = (props) => {
    return (
        <div className={`mr-4 u-phoneHide`}>
            <img src={props.image} alt={props.alt} className={`u-size42x42 u-block`} />
        </div>
    );
}

export default addonsImage;


// WEBPACK FOOTER //
// ./src/components/Addons/AddonsImage/AddonsImage.js